import DateFnsUtils from '@date-io/moment';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import {makeStyles} from '@material-ui/core/styles';
import {grey} from '@material-ui/core/colors';

export default function DateTime({
    label,
    disabled = false,
    placeholder,
    required,
    format,
    value,
    onChange,
    className,
    okLabel,
    cancelLabel,
    id,
    fullWidth = false,
}) {
    const classes = useStyles();

    return (
        <div className={className}>
            {!!label && (
                <label className={classes.label}>
                    {label} {!!required && '*'}
                </label>
            )}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    ampm={false}
                    variant="dialog"
                    inputVariant="outlined"
                    format={format}
                    required={required}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    id={id}
                    fullWidth={fullWidth}
                    inputProps={{
                        placeholder,
                        style: {
                            paddingTop: 8,
                            paddingBottom: 8,
                            backgroundColor: '#FFF',
                            borderRadius: 5,
                        },
                    }}
                    InputAdornmentProps={{
                        position: 'start',
                    }}
                    InputProps={{
                        style: {
                            backgroundColor: '#FFF',
                        },
                    }}
                    KeyboardButtonProps={{
                        style: {
                            padding: 0,
                        },
                    }}
                    okLabel={okLabel}
                    cancelLabel={cancelLabel}
                />
            </MuiPickersUtilsProvider>
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    label: {
        display: 'block',
        fontWeight: 'bold',
        color: grey[500],
        marginBottom: theme.spacing(1),
    },
}));
